import mallorca from '../assets/mallorca.jpg';
import france from '../assets/france.jpg';
import wellnesssuites from '../assets/wellnesssuite.jpg';
import ardennen from '../assets/ardennes.jpg';
import cotedazur from '../assets/cotedazur.jpg';
import spain from '../assets/spain.jpg';
import ibiza from '../assets/ibiza.jpg';
import austria from '../assets/voucher.jpg';
import luxemburg from '../assets/luxemburg.jpg';

const mappedHomeData = {
  mallorca,
  france,
  wellnesssuites,
  ardennen,
  cotedazur,
  spain,
  austria,
  ibiza,
  luxemburg,
};

export default mappedHomeData;
